import React from 'react';

const STEPS = [
  {
    n: 1,
    title: 'Connect Desigo',
    desc: 'Link your Siemens Desigo Optic instance. Projects, sites, and data points sync automatically into Manzili Smart.',
  },
  {
    n: 2,
    title: 'Configure Spaces',
    desc: 'Create buildings, floors, and rooms. Assign devices and map Desigo Optic points to each space.',
  },
  {
    n: 3,
    title: 'Assign Users',
    desc: 'Add partners and residents. Assign rooms and devices based on role — admins, managers, or residents.',
  },
  {
    n: 4,
    title: 'Control & Monitor',
    desc: 'Residents open Manzili Smart and control their environment in real time — HVAC, lighting, and more.',
  },
];

const HowItWorks = () => (
  <section className="how-it-works" id="how-it-works">
    <div className="hiw-inner">
      <span className="section-eyebrow" style={{ display: 'block', textAlign: 'center', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: '#00A7AA', marginBottom: '14px' }}>
        Getting Started
      </span>
      <h2 className="section-title">From Siemens Hardware to a Resident's Phone</h2>
      <p className="section-subtitle">Four simple steps to bring enterprise building automation to your residents.</p>
      <div className="steps-grid">
        {STEPS.map(s => (
          <div className="step-item" key={s.n}>
            <div className="step-number">{s.n}</div>
            <h5>{s.title}</h5>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
